module.exports = __webpack_public_path__ + "static/media/Purchase.7e36835f.svg";